import React from 'react';

type SvgWarningProps = {
  width?: number;
  height?: number;
};

export const WarningIcon = ({ width = 17, height = 16 }: SvgWarningProps): JSX.Element => (
  <svg width={width} height={height} viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    {/* eslint-disable-next-line i18next/no-literal-string */}
    <title>Warning</title>
    <path
      d='M8.431 5.885v1.664m0 3.328h.009m-5.773 3.329h11.529a1.664 1.664 0 0 0 1.44-2.497L9.873 1.725a1.664 1.664 0 0 0-2.882 0l-5.765 9.984a1.664 1.664 0 0 0 1.442 2.497Z'
      stroke='#D34A4A'
      strokeWidth='1.664'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
